import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import { Icons, MUI, Theme } from '../../styles';

// Material-UI Pickers
import { TimePicker, KeyboardTimePicker } from '@material-ui/pickers';

import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import moment from 'moment';
import MomentUtils from '@date-io/moment';
import 'moment/locale/en-gb';
import 'moment/locale/es-mx';
import 'moment/locale/pt';

// TextField TimePicker
const MuiTextFieldTimePicker = ({ ...props }) => {
  return (
    <MUI.TextField
      {...props}
      InputProps={{ endAdornment: (<Icons.Time />) }}
    />
  );
};

const MuiTimePicker = (props) => {
  const lsLanguage = JSON.parse(localStorage.getItem('ls.ty-Language'));
  const lang = lsLanguage ? lsLanguage.language : 'es';
  const locale = {
    en: 'en-gb',
    es: 'es-mx',
    pt: 'pt'
  };

  // Set moment locale
  moment.locale(locale[lang]);

  const materialTheme = createTheme({
    overrides: {
      MuiPickersToolbar: {
        toolbar: {
          height: '70px',
          backgroundColor: Theme.colors.blueDark,
          '& h2': {
            fontFamily: 'Bryant Pro Medium',
            fontSize: Theme.typography.heading2,
            fontWeight: 'normal',
            letterSpacing: 'normal',
            whiteSpace: 'normal',
          },
          '& h6': {
            fontFamily: 'Bryant Pro Medium',
            fontSize: Theme.typography.heading6,
            fontWeight: 'normal',
            letterSpacing: '0.0175em',
            whiteSpace: 'normal',
          },
        }
      },
      MuiPickersClock: {
        pin: {
          backgroundColor: Theme.colors.blueDark
        },
      },
      MuiPickersClockPointer: {
        pointer: {
          backgroundColor: Theme.colors.blueDark
        },
        noPoint: {
          backgroundColor: Theme.colors.blueDark
        },
        thumb: {
          borderColor: Theme.colors.blueDark
        }
      },
      MuiPickersClockNumber: {
        clockNumber: {
          color: Theme.colors.greyDark,
          fontFamily: 'Bryant Pro Regular',
          fontSize: Theme.typography.bodyText,
          fontWeight: 'normal',
          letterSpacing: '0.0175em',
          whiteSpace: 'normal',
        },
      }
    }
  });

  const {
    allowKeyboard,
    ...restProps
  } = props;

  return (
    <ThemeProvider theme={materialTheme}>
      <MuiPickersUtilsProvider utils={MomentUtils} locale={locale[lang]} moment={moment}>
        {!allowKeyboard ? (
          <TimePicker
            {...restProps}
            autoOk
            variant="inline"
            mask="__:__ _M"
            TextFieldComponent={MuiTextFieldTimePicker}
          />
        ) : (
          <KeyboardTimePicker
            {...restProps}
            autoOk
            variant="inline"
            mask="__:__ _M"
            keyboardIcon={<Icons.Time />}
            TextFieldComponent={MUI.TextField}
          />
        )}
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  );
};

MuiTimePicker.propTypes = {
  // Boolean to change TimePicker to KeyboardTimePicker.
  allowKeyboard: PropTypes.bool
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

/* KeyboardTimePicker Styles */
export const StyledTimePicker = styled(MuiTimePicker)`
  .MuiIconButton-root {
    padding: 8px;
    right: -8px;
    color: ${(props) => props.theme.colors.greyDark};
  }
`;